import { RouteObject } from "react-router-dom";
import UserManage from "./UserManage";
import UserDetailManage from "./UserDetailManage";
import AuthGuardWrapper from "../../auth/AuthGuardWrapper";
import {User} from "../../../commons/models/user";

export const routerAdminUser: RouteObject[] = [
  {
    path: "",
    element: <AuthGuardWrapper subject={User}><UserManage /></AuthGuardWrapper>,
  },
  {
    path: ":userId",
    element: <AuthGuardWrapper subject={User}><UserDetailManage /></AuthGuardWrapper>,
  },
];
